module.exports = __webpack_public_path__ + "assets/img/0e5e-fi.svg";